<template>
  <el-button class="submit" @click="dialogTableVisible = true"
    >查看记录</el-button
  >
  <el-dialog title="索赔记录" v-model="dialogTableVisible">
    <el-table :data="tableData">
      <el-table-column
        property="orderId"
        label="订单号"
        width="200"
      ></el-table-column>
      <el-table-column
        property="cost"
        label="金额"
        width="250"
      ></el-table-column>
      <el-table-column prop="tag" label="状态" width="150">
        <template #default="scope">
          <el-tag type="warning">处理中</el-tag>
        </template>
      </el-table-column>
    </el-table>
  </el-dialog>
</template>

<script>
import { defineComponent, ref, getCurrentInstance, onMounted } from 'vue';
import { Order } from '@/utils/api/order';
export default defineComponent({
  name: 'ClaimDialog',
  setup() {
    const tableData = ref([]);
    const dialogTableVisible=ref(false);
    const dialogFormVisible=ref(false);
    const getOrder = () => {
      Order.getCliamOrder()
        .then((res) => {
          if (res.status === 200) {
            tableData.value = res.data;
            console.log(tableData);
          }
        })
        .catch((error) => {
          console.log(error);
        });
    };
    onMounted(() => {
      getOrder();
    });
    const { ctx } = getCurrentInstance();
    const handleEdit = () => {
      ctx.$confirm('申请成功，申请状态将在记录中显示', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
      });
    };
    return {
      dialogTableVisible,
      dialogFormVisible,
      tableData,
      getOrder,
      handleEdit,
    };
  },
});
</script>
<style lang="scss" scoped>
@import '@/assets/css/config.scss';

.el-button--primary {
  color: #fff;
  background-color: rgb(166, 196, 227);
  border-color: rgb(190, 211, 235);
}
.submit {
  height: 20px;
  width: 100px;
  margin-left: 50px;
  background-color: $themeRed;
  color: white;
  font-weight: 600;
}
</style>
